export class Service {
    name = '';
    encryptionRequired = true;
    terminatorStrategy = '';
    roleAttributes: any[] = [];
    tags: any = {};
    configs: any[] = [];
    maxIdleTimeMillis = 0;
};